<template>
  <div
    class="card"
    :class="[
      `card--${size}`,
      { 'card--no-header': !title && !$slots.header },
      { 'card--flush': flush },
    ]"
  >
    <div v-if="title || $slots.header || $slots.actions" class="card__header">
      <div class="card__header-left">
        <slot name="header">
          <div class="card__titles">
            <h3 v-if="title" class="card__title">{{ title }}</h3>
            <p v-if="subtitle" class="card__subtitle">{{ subtitle }}</p>
          </div>
        </slot>
      </div>
      <div v-if="$slots.actions" class="card__actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="card__body">
      <slot />
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Card',
    props: {
      title: {
        type: String,
        default: null,
      },
      subtitle: {
        type: String,
        default: null,
      },
      size: {
        type: String,
        default: 'md',
        validator: (value) => ['sm', 'md', 'lg'].includes(value),
      },
      flush: {
        type: Boolean,
        default: false,
      },
    },
  });
</script>

<style scoped lang="scss">
  .card {
    position: relative;
    box-shadow:
      0 0 #0000,
      0 0 #0000,
      0 1px 2px 0 rgb(0 0 0 / 0.05);
    background-color: #ffffff;
    border-radius: 0.5rem;
    border: 1px solid var(--slate-200);
    padding: 0;

    &--sm {
      .card__header {
        padding: 0.625rem 1rem;
      }

      .card__body {
        padding: 1rem;
      }

      .card__title {
        font-size: 0.875rem;
      }
    }

    &--md {
      .card__header {
        padding: 0.75rem 1rem;
      }

      .card__body {
        padding: 1rem;
      }

      .card__title {
        font-size: 0.9375rem;
      }
    }

    &--lg {
      .card__header {
        padding: 1rem 1.5rem;
      }

      .card__body {
        padding: 1.5rem;
      }

      .card__title {
        font-size: 1.125rem;
      }
    }

    &--no-header {
      .card__body {
        padding-top: 1.5rem;
      }

      &.card--sm .card__body {
        padding-top: 1rem;
      }
    }

    &--flush {
      .card__body {
        padding: 0;
      }
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      border-bottom: 1px solid var(--slate-200);
    }

    &__header-left {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      flex: 1;
      min-width: 0;
    }

    &__titles {
      display: flex;
      flex-direction: column;
      gap: 0.125rem;
    }

    &__title {
      margin: 0;
      font-weight: 600;
      color: var(--slate-900);
    }

    &__subtitle {
      margin: 0;
      font-size: 0.8125rem;
      color: var(--slate-500);
      font-weight: 400;
    }

    &__actions {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      flex-shrink: 0;
    }
  }
</style>
